import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { PRICE, PRICE_PLN } from '../data/valueStack';
import { CtaButton } from './CtaButton';
type InlineCtaTone = 'night' | 'night-900' | 'wine-dark';
interface InlineCtaProps {
  label: string;
  /** Matches the background of the section this button sits under. */
  tone?: InlineCtaTone;
}
const toneClasses: Record<InlineCtaTone, string> = {
  night: 'bg-night',
  'night-900': 'bg-night-900',
  'wine-dark': 'bg-wine-dark'
};

/** Buy button placed at the end of a section, straight to checkout. */
export function InlineCta({
  label,
  tone = 'night'
}: InlineCtaProps) {
  return <div className={`${toneClasses[tone]} -mt-4 pb-16 sm:-mt-8 sm:pb-24`} data-id="element-217" data-mp="2li1wnvtvemj0">
      <div className="mx-auto flex max-w-shell flex-col items-center gap-3 px-5 text-center sm:px-6" data-id="element-218" data-mp="2pkgdkadzbc7n">
        <CtaButton size="lg" data-id="element-219" data-mp="r7pvvhemgfgj">{label}</CtaButton>
        <p className="text-xs text-amber-light" data-id="element-220" data-mp="v7gto52kfvuk">
          {PRICE} <span className="text-cream-muted" data-id="element-221" data-mp="v80dxsfouwbr">({PRICE_PLN})</span> · płatność jednorazowa
        </p>
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-[11px] text-cream-muted" data-id="element-222" data-mp="2zz86a8dcun8p">
          <span className="flex items-center gap-1.5" data-id="element-223" data-mp="2v5vvb11lmeyf">
            <LockIcon className="h-3 w-3 text-amber" aria-hidden="true" data-id="element-224" data-mp="2q7auazeivr8x" /> Bezpieczna płatność
          </span>
          <span className="flex items-center gap-1.5" data-id="element-225" data-mp="2la27glifiz1c">
            <ZapIcon className="h-3 w-3 text-amber" aria-hidden="true" data-id="element-226" data-mp="3iwrhninachya" /> Natychmiastowy dostęp
          </span>
          <span className="flex items-center gap-1.5" data-id="element-227" data-mp="3dxy3do06cmx2">
            <ShieldCheckIcon className="h-3 w-3 text-amber" aria-hidden="true" data-id="element-228" data-mp="3dyg8790wk9gl" /> 10 dni gwarancji
          </span>
        </div>
      </div>
    </div>;
}